import { render, staticRenderFns } from "./request-general-info.vue?vue&type=template&id=a5d0fdd8&lang=pug&"
import script from "./request-general-info.vue?vue&type=script&lang=js&"
export * from "./request-general-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports